import React, { createContext } from 'react'
import { useMemo, useState } from 'sb-hooks'


type AccordionContextValue = {
  activeItem: string
  setActiveItem: (id?: string) => void
}

type AccordionProps = {
  initialActiveItem?: string
}

export const AccordionContext = createContext<AccordionContextValue>(null)

const Accordion: React.FunctionComponent<AccordionProps> = (props) => {
  const { children, initialActiveItem } = props

  const [ activeItem, setActiveItem ] = useState<string>(initialActiveItem || null)

  const contextValue = useMemo(() => ({
    activeItem,
    setActiveItem,
  }), [ activeItem ])

  return (
    <AccordionContext.Provider value={contextValue}>
      {children}
    </AccordionContext.Provider>
  )
}


export default Accordion
